import React, { useRef } from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { Icon, type IconName, theme, usePressableState } from '@sg/garnish';

export const HomeHeroCta = (props: HomeHeroCtaProps) => {
  const { accessibilityLabel, iconName, onPress, iconSize = 40 } = props;
  const ref = useRef(null);
  const { isInteracting } = usePressableState(ref);
  const interactiveStyle = isInteracting
    ? styles.heroCtaInteractiveState
    : null;

  return (
    <Pressable
      ref={ref}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
      style={[styles.heroCta, interactiveStyle]}
      onPress={onPress}
    >
      <Icon name={iconName} width={iconSize} height={iconSize} />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  heroCta: {
    width: 48,
    height: 48,
    backgroundColor: theme.colors.OATMEAL,
    padding: theme.spacing['1'],
    borderRadius: theme.radius['3xLarge'],
    alignItems: 'center',
    justifyContent: 'center',
    ...theme.elevations['4'],
  },
  heroCtaInteractiveState: {
    backgroundColor: theme.colors.QUINOA_HOVER,
  },
});

type HomeHeroCtaProps = {
  accessibilityLabel: string;
  iconName: IconName;
  onPress: () => void;
  iconSize?: number;
};
